<template>
  <div class="Winner fixed-fullscreen justify-align-center" @click.self="close">
    <div class="wrapper">
      <div class="title">
        <span>{{ mission.name }} {{ i+1 }}위</span>
        <span>{{ mission.scores[i] }}점</span>
      </div>
      <div class="players v-list">
        <div class="player v-list-item px-2 transition-800ms"
          v-for="player in players"
          :key="player.rank"
          :class="[player.team]"
          @click="select(player)"
        >
          <span class="v-list-item-avatar">
            <img :src="'/static/img/' + player.avatar + '_Portrait.png'" :alt="player.name">
          </span>
          <div class="v-list-item-content">
            <div class=name>{{ player.name }}</div>
            <div class=rank>{{ player.rank }} 위</div>
          </div>
          <div class="v-list-item-score">
            {{ player.score }}
          </div>
        </div>
      </div>
      <div class="remove my-1 text-center cursor-pointer" @click="select({id: ''})">제거</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Winner',
  props: ['players', 'mission', 'i'],
  data: () => ({
  }),
  methods: {
    select (player) {
      this.$socket.client.emit('updateWinner', {
        code: this.mission.code,
        index: this.i,
        winner: player.id
      })
      this.$emit('close')
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.Winner.fixed-fullscreen {
  background: #0000;
  border: none;
  z-index: 50;
}
.Winner .wrapper {
  width: 90vw;
  max-width: 480px;
  height: 90vh;
  max-height: 640px;
  text-align: left;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 5px #000a;
}
.title {
  display: flex;
  justify-content: space-between;
  padding: .5em 1em;
  font-weight: bolder;
}
.v-list-item {
  cursor: pointer;
}
.v-list-item-avatar img {
  transition: transform .5s;
}
.v-list-item:hover img {
  transform: scale(1.1, 1.1);
}
.v-list-item-content>.name {
  font-size: 14px;
  font-weight: 1000;
  white-space: nowrap;
}
.v-list-item-content .twitch {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  background-image: url('/static/img/twitch.png');
  background-size: 16px 16px;
  vertical-align: -3px;
}
.v-list-item-content>.rank,
.v-list-item-content>.team {
  color: #53535f;
  font-size: 13px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Mission/Winner.vue